import { IController } from 'angular';
import * as _ from 'lodash';
import {
  IPriorityGroupDefinition,
  RegentsPrepPriorityGroupingsService,
} from '../../../../../../../../../shared/services/regents-prep-priority-groupings/regents-prep-priority-groupings.service';
import { WizardUtils } from '../../../../../../../../../shared/services/wizard-utils/wizard-utils.service';

interface IPriorityGroupCopy extends IPriorityGroupDefinition {
  studentIds: string[];
  examCount: number;
}

export class StudentReviewCtrl implements IController {
  public filteredStudents;
  public organizedPriorityData;
  public totalStudents;
  public totalExams;
  public options;

  static $inject = ['$scope', 'ObjectCache', '$state', 'WizardUtils', 'RegentsPrepPriorityGroupingsService'];

  constructor(
    public $scope,
    private ObjectCache,
    private $state,
    private WizardUtils: WizardUtils,
    private RegentsPrepPriorityGroupingsService: RegentsPrepPriorityGroupingsService,
  ) {
    //
  }

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi() {
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.organizedPriorityData = this.organizeStudentsByPriority(this.filteredStudents);
    this.totalStudents = this.getTotalStudents(this.organizedPriorityData);
    this.totalExams = this.getTotalExams(this.organizedPriorityData);
    this.options = {
      columnKeys: ['cohort', 'gradPlan', 'regentsSchedNextAdminWithNoPrep'],
    };
  }

  goToStudentProfile = studentIds => {
    const filter = this.ObjectCache.cacheObject({ studentId: studentIds });
    this.$state.go(`main.school.new-sdc.regents-prep.profile`, { filter });
  };

  private getTotalStudents = priorityGroups => {
    return _.reduce(
      priorityGroups,
      (result, priorityGroup: any) => {
        result = result.concat(priorityGroup.studentIds);
        return result;
      },
      [],
    );
  };

  private getTotalExams = priorityGroups => {
    return _.reduce(
      priorityGroups,
      (result, priorityGroup: any) => {
        result += priorityGroup.examCount;
        return result;
      },
      0,
    );
  };

  private organizeStudentsByPriority = students => {
    const regentsPrepPriorityGroups = this.RegentsPrepPriorityGroupingsService.getPriorityGroupsByStudentYearFilter();

    // copy and remove the last priority group because those are students who don't need any prep
    const priorityGroupCopy = _.dropRight(_.cloneDeep(regentsPrepPriorityGroups));

    const priorityGroups = _.map(priorityGroupCopy, (group: IPriorityGroupCopy) => {
      group.studentIds = [];
      group.examCount = 0;
      return group;
    });

    _.each(students, (student: any) => {
      const { studentId, regentsPrepPriorityGrouping, countOfRegentsSchedNextAdminWithNoPrep } = student;
      if (regentsPrepPriorityGrouping) {
        const group = _.find(priorityGroups, { studentPriorityGroupingValue: regentsPrepPriorityGrouping });
        if (group) {
          group.studentIds.push(studentId);
          group.examCount += countOfRegentsSchedNextAdminWithNoPrep;
        }
      }
    });
    return priorityGroups;
  };
}
